module.exports = __webpack_public_path__ + "static/Resume.8eccfb11.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Resume.pdf
// module id = 953
// module chunks = 35783957827783